import { createSlice } from "@reduxjs/toolkit";
import { modulesAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const modulesSlice = createSlice({
  name: "modules",
  initialState: data,
  reducers: {
    modulesSlice(state) {
      state.isLoading = false;
    },
    modulesSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    modulesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    modulesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const modulesHandler = () => async (dispatch: any) => {
  try {
    dispatch(modulesAction.modulesSlice());
    const response: any = await modulesAPI();
    dispatch(modulesAction.modulesSliceSuccess(response));
  } catch (e: any) {
    dispatch(modulesAction.modulesSliceFailure(e?.response?.data?.message));
    dispatch(modulesAction.modulesSliceReset());
  }
};
export default modulesSlice.reducer;
export const modulesAction = modulesSlice.actions;
